import { IntegrationIconProps } from './types';

const Java = ({ dimension }: IntegrationIconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.0488 8.44062C22.6369 3.32607 19.2557 0 19.2557 0C19.7588 5.28738 13.812 6.53583 12.218 10.1692C11.1302 12.6485 12.9628 14.8193 16.0466 17.5554C15.7739 16.9494 15.3535 16.3606 14.9278 15.7645C13.476 13.7313 11.9635 11.6132 16.0488 8.44062Z"
      fill="#E76F00"
    />
    <path
      d="M17.1005 18.677C17.1005 18.677 19.0826 17.0779 17.5129 15.3008C12.1921 9.27186 23.3323 6.53583 23.3323 6.53583C16.5308 9.8125 17.5462 11.7574 19.2557 14.1202C21.0861 16.6538 17.1005 18.677 17.1005 18.677Z"
      fill="#E76F00"
    />
    <path
      d="M22.937 23.4456C29.0423 20.3258 26.2195 17.3278 24.2492 17.7317C23.7662 17.8305 23.5509 17.9162 23.5509 17.9162C23.5509 17.9162 23.7302 17.64 24.0726 17.5204C27.9705 16.1729 30.9682 21.4949 22.8143 23.6028C22.8143 23.6029 22.9088 23.5198 22.937 23.4456Z"
      fill="#5382A1"
    />
    <path
      d="M10.233 19.4969C6.41312 18.9953 12.3275 17.6139 12.3275 17.6139C12.3275 17.6139 10.0307 17.4616 7.20592 18.8043C3.86577 20.3932 15.4681 21.1158 21.474 19.5625C22.0984 19.1432 22.9614 18.7798 22.9614 18.7798C22.9614 18.7798 20.5037 19.2114 18.0561 19.4145C15.0612 19.6612 11.8459 19.7093 10.233 19.4969Z"
      fill="#5382A1"
    />
    <path
      d="M11.6864 22.4758C9.55624 22.2592 10.951 21.2439 10.951 21.2439C5.43898 23.0429 14.0178 25.083 21.7199 22.8682C20.9012 22.5844 20.3806 22.0653 20.3806 22.0653C16.6163 22.7781 14.441 22.7553 11.6864 22.4758Z"
      fill="#5382A1"
    />
    <path
      d="M12.6145 25.6991C10.486 25.4585 11.7295 24.7474 11.7295 24.7474C6.72594 26.1222 14.7729 28.9625 21.1433 26.2777C20.0999 25.8787 19.3528 25.4181 19.3528 25.4181C16.5111 25.9469 15.1931 25.9884 12.6145 25.6991Z"
      fill="#5382A1"
    />
    <path
      d="M25.9387 27.3388C25.9387 27.3388 26.8589 28.0844 24.9252 28.6612C21.2481 29.7566 9.62093 30.0874 6.39094 28.7049C5.22984 28.2082 7.40723 27.5189 8.09215 27.3742C8.80646 27.2219 9.21466 27.2503 9.21466 27.2503C7.9234 26.3558 0.868489 29.0067 5.63111 29.7659C18.6195 31.8372 29.3077 28.8331 25.9387 27.3388Z"
      fill="#5382A1"
    />
    <path
      d="M28 28.9679C27.7869 31.6947 18.7877 32.2683 12.9274 31.8994C9.10432 31.6583 8.33812 31.0558 8.32691 31.047C11.9859 31.6402 18.1549 31.7482 23.1568 30.8225C27.5903 30.0016 28 28.9679 28 28.9679Z"
      fill="#5382A1"
    />
  </svg>
);
export default Java;
